import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table, Col, Row, Label } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { withNamespaces } from 'react-i18next';
import showNotification from '../helpers/show_notification';


const UpdateQuantityForPOModal = ({
  isOpen,
  toggle,
  onSubmit,
  item,
  cartItems,
  setCartItems,
  selectedItems,
  // handlePriceChange,
  t 
}) => {
  const [selectedItem, setSelectedItem] = useState({})

  useEffect(() => {
    if (!item) {
      setSelectedItem({});
      return;
    }
    const quantity = (Array.isArray(item.quantity) ? item.quantity : []).map((qty, index) => ({
      ...qty,
      index: qty.index ?? index,
      isChecked:
        qty.isChecked !== undefined && qty.isChecked !== null
          ? qty.isChecked
          : Number(qty.value) > 0,
    }));
    setSelectedItem({ ...item, quantity });
  }, [item])

  const handleQuantityUpdate = (index, quantity, newunit) => {
    setSelectedItem(prevSelectedItems => {
      // const updatedUnits = prevSelectedItems.quantity.map((unit, i) =>
      //   newunit === unit.unit ? { ...unit, value: quantity } : i === index ? { ...unit, value: quantity } : unit
      //  );
      // return { ...prevSelectedItems, quantity: updatedUnits };
      return {
        ...prevSelectedItems,
        quantity: prevSelectedItems.quantity.map((u) => u.unit === newunit ? { ...u, value: quantity } : u)
      }
    });
  };

  const handleCheckboxUpdate = (index, unitObj, setSelectedItem) => {
    setSelectedItem((prev) => {
      const updatedQuantity = [...prev.quantity];
      const existingUnitIndex = updatedQuantity.findIndex(
        (unit) => unit.unit === unitObj.unit
      );

      // Check for last checked unit
      if (existingUnitIndex !== -1 && 
        updatedQuantity[existingUnitIndex].isChecked &&
        updatedQuantity.filter(unit => unit.isChecked).length === 1) {
        showNotification("You must have at least one unit checked.", "Warning");
        return prev;
      }

      if (existingUnitIndex === -1) {
        updatedQuantity.push({
          unit: unitObj.unit,
          // formula: unitObj.value,
          value: 0,
          index,
          isChecked: true,
        });
      } else {
        if (updatedQuantity[existingUnitIndex].isChecked ) {
          updatedQuantity.splice(existingUnitIndex, 1);
        } else {
          updatedQuantity[existingUnitIndex].isChecked = true;
        }
      }
      updatedQuantity.sort((a, b) => {
        const unitA = prev?.unit_levels.find(u => u.unit === a.unit);
        const unitB = prev?.unit_levels.find(u => u.unit === b.unit);
        return unitA.value - unitB.value;
      });
      // console.log(updatedQuantity,"after");

      return { ...prev, quantity: updatedQuantity };
    });
  };

  const handlePriceChange = (e) => {
    const isItemInCart = cartItems.some(
      (item) => item.item_id === selectedItems.item_id
    );
    if (isItemInCart) {
      const updatedCartItems = cartItems.map((item) =>
        item.item_id === selectedItems.item_id
          ? { ...item, price: +e.target.value }
          : item
      );
      setCartItems(updatedCartItems);
    }
  };
  const handleSubmit = () => {
      onSubmit(selectedItem.quantity);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        {t("Enter Quantity")}
      </ModalHeader>
      <ModalBody>
        <AvForm onValidSubmit={handleSubmit}>
          <Col lg={12}>
            <Table bordered size="sm" responsive className="table table-sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("Unit")}</th>
                  <th>{t("Quantity")}</th>
                  <th>{t("formula")}</th>
                </tr>
              </thead>
              <tbody>
              {selectedItem &&
                        selectedItem.unit_levels?.map((unitObj, index) => {
                          let prevUnit;
                          if (index == 0) {
                            prevUnit = "NA";
                          } else
                            prevUnit =
                              selectedItem?.unit_levels[index - 1].unit;
                          const selectedUnit = selectedItem?.quantity?.find(
                            (su) => su.unit === unitObj.unit
                          );                  
                  return (
                    <tr key={index}>
                      <td>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedUnit?.isChecked}
                            onChange={() =>
                              handleCheckboxUpdate(index, unitObj, setSelectedItem)
                            }                             />
                        </div>
                      </td>
                      <td onClick={() => handleCheckboxUpdate(index, unitObj, setSelectedItem)}>
                        {unitObj.unit}
                      </td>
                      <td>
                        <AvField
                           key={`${selectedItem.item_id || selectedItem.product_id || "item"}-${unitObj.unit}`}
                           type="number"
                           placeholder=""
                           className="form-control"
                           disabled={selectedUnit?.isChecked ? false : true}
                           style={{ width: "60px", height: "20px" }}
                           name={unitObj.unit}
                           value={selectedUnit?.isChecked ? selectedUnit.value.toString() : ''}
                           validate={{
                             required: { value: selectedUnit?.isChecked ? true : false },
                             pattern: {
                              value: "^[0-9]+$",
                              errorMessage: t("Only whole numbers are allowed"),
                            },
                             min: { value: 1, errorMessage: 'can not be zero' },
                           }}
                           errorMessage={t("Qty. can't be empty")}
                          onChange={(e) => {
                            const quantity = e.target.value;
                            handleQuantityUpdate(index, Number(quantity), unitObj.unit);
                          }}
                        />
                      </td>
                      <td>
                        {index > 0
                          ? `1 ${prevUnit} = ${unitObj.value} ${unitObj.unit}`
                          : "NA"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
          <Row>
                  <Col lg={4} md={4} sm={4} className="d-flex justify-content-end">
                    {t("Price")}
                  </Col>
                  <Col lg={4} md={4} sm={4}>
                    <AvField
                      type="number"
                      name="price"
                      value={item?.price}
                      className="form-control"
                      onChange={(e) => handlePriceChange(e)}
                      style={{ height: "20px" }}
                      validate={{
                        required: { value: true, errorMessage: t("Price is required") },
                        min: {
                          value: 0.1,
                          errorMessage: t("Value must be greater than or equal to 0.1"),
                        },
                      }}
                      errorMessage={t("Price is required")}
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4}>
                    / {item?.unit_for_po ?? item.unit_for_cost_price}
                  </Col>
                </Row>
          <Row className="mt-3">
            <Col lg={12}>
              <div className="text-center">
                <Button type="submit" color="primary">
                  {t("Add")}
                </Button>
              </div>
            </Col>
          </Row>
        </AvForm>
      </ModalBody>
    </Modal>
  );
};

export default withNamespaces()(UpdateQuantityForPOModal);